<template>
    <div class="page-content">
        <!--    页面标题 start -->
        <div v-web-title :data-title="$t('message.feedback.title')"></div>
        <!--    页面标题 end -->


        <Row type="flex" justify="center">
            <!--        侧边栏 start -->
            <i-col :lg="4">
                <SideBar class="mobile-no-sidebar" />
            </i-col>
            <!--        侧边栏 end -->

            <!--            意见和建议 start-->
            <i-col :xs="24" :md="24" :lg="12">
                <div class="feedback-block">
                    <div class="feedback-header">
                        <div class="feedback-title">{{$t('message.feedback.submitHeaderTitle')}}</div>
                        <div class="feedback-icon">
                            <m-icons type="ico_feedback" size="30" color="#0d6fb8"></m-icons>
                        </div>
                    </div>

                    <div class="line line-wrapper" />

                    <div class="feedback-input-block">
                        <Form ref="feedback" :model="feedback" :rules="feedbackRules" >
                            <FormItem :label="$t('message.feedback.feedbackReason')" prop="reason">
                                <i-select v-model="feedback.reason" :placeholder="$t('message.feedback.feedbackReasonPlaceholder')">
                                    <Option v-for="(reason, index) in feedbackReasons" :key="index" :value="reason">{{reason}}</Option>
                                </i-select>
                            </FormItem>
                            <FormItem prop="content">
                                <Input type="textarea" v-model="feedback.content"
                                       :autosize="{minRows: 10, maxRows: 20}"
                                       :placeholder="$t('message.feedback.feedbackContentPlaceholder')" />
                            </FormItem>
                            <FormItem class="feedback-buttons">
                                <Button class="feedback-submit-button" type="primary" @click="submitFeedback">{{$t('message.feedback.submitButton')}}</Button>
                                <Button class="feedback-reset-button" type="default" @click="resetFeedback">{{$t('message.feedback.resetButton')}}</Button>
                            </FormItem>
                        </Form>
                    </div>

                </div>
            </i-col>
            <!--            意见和建议 end-->

        </Row>


    </div>
</template>

<script>
  import SideBar from "../../components/SideBar/SideBar";
  import MIcons from "../../components/m-icons/m-icons";
  import {urlRequest} from "../../common/common";
  export default {
    name: "SubmitFeedback",
    components: {MIcons, SideBar},
    data() {
      return {
        // 反馈标题，从前页传来
        feedbackTitle: '',
        // 反馈原因数据，从前页传来
        feedbackReasons: [],
        // 反馈数据
        feedback: {
          // 反馈原因
          reason: '',
          // 反馈内容
          content: '',
        },
        // 反馈数据校验
        feedbackRules: {
          reason: [
            {required: true, message: this.$t('message.feedback.feedbackReasonRequired'), trigger: 'blur'}
          ],
          content: [
            {required: true, message: this.$t('message.feedback.feedbackContentRequired'), trigger: 'blur'}
          ],
        }
      }
    },

    created() {
      console.log('前页传来的参数: ', this.$route.query);
      let {title, reasons} = this.$route.query;
      this.feedbackTitle = title;
      this.feedbackReasons = JSON.parse(reasons);
    },

    methods: {
      // 提交反馈
      submitFeedback() {
        this.$refs.feedback.validate(valid => {
          if (valid) {
            // 校验成功，调用反馈接口提交
            urlRequest({
              url: this.api.feedback,
              method: 'POST',
              data: {
                'opinion': `${this.feedbackTitle}-${this.feedback.reason}: ${this.feedback.content}`,
              }
            }).then(res => {
              this.$Message.success(res.data.msg);
              this.$router.replace('Me');
            });
          }
        });
      },
      // 重置反馈
      resetFeedback() {
        this.$refs.feedback.resetFields();
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "SubmitFeedback.scss";

</style>
